import React from "react";
import { withRouter } from "react-router-dom";
import RestaurantCard from "./RestaurantCard";
import RestaurantProfile from "./RestaurantProfile";
import RestaurantListing from "./RestaurantListing";
import RestuarantListCard from "./RestaurantListCard";
import RestaurantCardInfo from "./RestaurantCardInfo";
import RestaurantGridCard from "./RestaurantGridCard";
import RestaurantMenuCard from "./RestaurantMenuCard";

const RestaurantComponent = props => {
  switch (props.type) {
    case "profile":
      return <RestaurantProfile {...props} />;
    case "listing":
      return <RestaurantListing {...props} />;
    case "list-card":
      return <RestuarantListCard {...props} />;
    case "card-info":
      return <RestaurantCardInfo {...props} />;
    case "menu-card":
      return <RestaurantMenuCard {...props} />;
    case "grid":
      return <RestaurantGridCard {...props} />;
    default:
      return <RestaurantCard {...props} />;
  }
};

export default withRouter(RestaurantComponent);
